import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';

export const Wrapper = withConfig(theme => styled('div', { label: 'Wrapper' })`
    background-color: ${theme.star.layoutGlobal.bgColor};
`);

export const SectionWrapper = styled('div', { label: 'SectionWrapper' })`
    display: flex;
    flex-flow: column nowrap;
    flex: 1 1 0%;
`;
